
var id = "qrText";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"qrText\"><defs><style type=\"text/css\"></style></defs><path d=\"M192 438.4c12.8 0 24-11.2 24-24V256c0-22.4 17.6-40 40-40h158.4c12.8 0 24-11.2 24-24s-11.2-24-24-24H256c-48 0-88 40-88 88v158.4c0 12.8 11.2 24 24 24zM768 168h-158.4c-12.8 0-24 11.2-24 24s11.2 24 24 24H768c22.4 0 40 17.6 40 40v158.4c0 12.8 11.2 24 24 24s24-11.2 24-24V256c0-48-40-88-88-88zM832 585.6c-12.8 0-24 11.2-24 24V768c0 22.4-17.6 40-40 40h-158.4c-12.8 0-24 11.2-24 24s11.2 24 24 24H768c48 0 88-40 88-88v-158.4c0-12.8-11.2-24-24-24zM414.4 808H256c-22.4 0-40-17.6-40-40v-158.4c0-12.8-11.2-24-24-24s-24 11.2-24 24V768c0 48 40 88 88 88h158.4c12.8 0 24-11.2 24-24s-11.2-24-24-24zM832 488H192c-12.8 0-24 11.2-24 24s11.2 24 24 24h640c12.8 0 24-11.2 24-24s-11.2-24-24-24z\" p-id=\"2391\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
